@if (isAgreementVoid != null) {
  <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-around center">
    @if (isAgreementVoid) {
      <mat-icon class="check-circle-icon">check_circle</mat-icon>
    }
    @if (isAgreementVoid) {
      <h2>{{ 'SuccessfullyApprovedAgreementVoiding' | translate }}</h2>
    }
    @if (!isAgreementVoid) {
      <mat-icon class="error-icon">error</mat-icon>
    }
    @if (!isAgreementVoid) {
      <h2>{{ 'FailedApprovingAgreementVoiding' | translate }}</h2>
    }
  </div>
}
